<!-- START first screen -->
<section class="contacts_first_screen">
    <div class="inner">
        <ng-container
            *ngIf="MessageFrom === 'TUU'; then titleTUU; else title"
        ></ng-container>

        <ng-template #titleTUU>
            <h1 class="ttl1">
                <span class="title1">{{ Title }}</span>
                <span class="gochi">{{ Title2 }}</span>
            </h1>
        </ng-template>

        <ng-template #title>
            <h1 class="ttl1">{{ Title }}</h1>
        </ng-template>

        <div class="block_contacts">
            <ng-template [ngIf]="!!isPromoForm === false">
                <p class="ttl2">Llámanos al</p>
                <a href="tel:{{ phoneSelected }}" class="tel">
                    <mat-icon>phone</mat-icon>{{ phoneSelected }}
                </a>
                <!-- START menuCountry -->
                <div class="menuCountry">
                    <!-- <div class="menuCountry__btn" [matMenuTriggerFor]="menu"> -->
                    <div class="menuCountry__btn">
                        <span class="flag">
                            <img [src]="flagSelected" 
                            width="28px"
                            height="20px"
                                [alt]="countrySelected" />
                        </span>
                        {{ citySelected }}, <b>{{ countrySelected }}</b>
                        <!-- <mat-icon>keyboard_arrow_down</mat-icon> -->
                    </div>

                    <!-- <mat-menu class="menuCountry__menu" #menu="matMenu">
            <button
              mat-menu-item
              *ngFor="let contact of contactList"
              [class.active]="countrySelected === contact.country ? true : false"
              (click)="selectedCountry(contact.country)">
              <span class="flag">
                <img src="{{contact.flag_url}}" [alt]="contact.country">
              </span>
              <span class="city">{{contact.city}}, </span>
              <span class="country">{{contact.country}}</span>
            </button>
          </mat-menu> -->
                </div>
                <!-- END menuCountry -->
            </ng-template>
        </div>
    </div>
</section>
<!-- END first screen -->

<section class="contactWrapper">
    <ul class="listCounrty">
        <li
            *ngFor="let icontact of allContactList"
            [style.display]="
                countrySelected === icontact.country ? 'none' : 'flex'
            "
        >
            <ng-container *ngIf="countrySelected !== icontact.country">
                <span>
                    <span class="flag">
                        <img
                            src="{{ icontact.flag_url }}"
                            width="28px"
                            height="20px"
                            alt="{{ icontact.country }}"
                        />
                    </span>
                    {{ icontact.city }}, <b>{{ icontact.country }}</b>
                </span>
                <a href="tel:{{ icontact.main_phone }}" class="phone">{{
                    icontact.main_phone
                }}</a>
            </ng-container>
        </li>
    </ul>

    <!-- START from -->
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="cardForm">
        <h3 class="ttl3" *ngIf="!!TitleForm">{{ TitleForm }}</h3>

        <div class="cardForm__form">
            <!-- Start Nombre -->
            <mat-form-field appearance="fill">
                <mat-label>Nombre</mat-label>
                <input id="name" matInput formControlName="name" required />
                <mat-error
                    *ngIf="
                        form.get('name').touched &&
                        form.get('name').hasError('required')
                    "
                >
                    Su nombre completo es requerido.
                </mat-error>
                <mat-error
                    *ngIf="
                        form.get('name').touched &&
                        form.get('name').hasError('minlength')
                    "
                >
                    Su nombre debe contener al menos tres caracteres.
                </mat-error>
                <mat-error
                    *ngIf="
                        form.get('name').touched &&
                        form.get('name').hasError('maxlength')
                    "
                >
                    Su nombre debe contener como máximo 100 caracteres.
                </mat-error>
            </mat-form-field>
            <!-- End Nombre -->

            <!-- Start Rut -->
            <mat-form-field appearance="fill" *ngIf="isRequestQuote">
                <mat-label>Rut</mat-label>
                <input matInput formControlName="rut" />
            </mat-form-field>
            <!-- End Rut -->

            <!-- Start Teléfono -->
            <div class="input-in-a-row field_row">
                <mat-form-field appearance="fill">
                    <mat-label>Teléfono</mat-label>
                    <span class="code">{{ contact.phone_code }}</span>
                    <input
                        id="phone"
                        type="text"
                        matInput
                        formControlName="phone"
                        matInput
                        [ngClass]="{ 'is-invalid': form.get('phone').errors }"
                        (blur)="onPhoneBlur($event)"
                        (focus)="onPhoneFocus($event)"
                    />
                    <!-- <mat-error *ngIf="form.get('phone').touched && form.get('phone').hasError('required')">Su teléfono es requerido.</mat-error> -->
                    <mat-error
                        *ngIf="
                            form.get('phone').touched &&
                            form.get('phone').hasError('pattern')
                        "
                    >
                        Su teléfono no tiene formato correcto.
                    </mat-error>

                    <span matPrefix>
                        <div class="flagsSelect {{ contact.country_code }}">
                            <mat-select
                                [(value)]="contact"
                                tabindex="-1"
                                (selectionChange)="
                                    changeValidation($event.value)
                                "
                            >
                                <mat-option
                                    *ngFor="let contact of allContactList"
                                    [value]="contact"
                                >
                                    <span class="flag">
                                        <img
                                            src="{{ contact.flag_url }}"
                                            alt="{{ contact.country }}"
                                        />
                                    </span>
                                    <span class="city"
                                        >{{ contact.city }},
                                    </span>
                                    <span class="country">{{
                                        contact.country
                                    }}</span>
                                </mat-option>
                            </mat-select>
                        </div>
                    </span>
                </mat-form-field>
            </div>
            <!-- End Teléfono -->

            <!-- Start Email -->
            <mat-form-field appearance="fill">
                <mat-label>E-mail</mat-label>
                <input
                    id="email"
                    matInput
                    formControlName="email"
                    required
                    email
                    [ngClass]="{ 'is-invalid': form.get('email').errors }"
                />
                <mat-error
                    *ngIf="
                        form.get('email').touched &&
                        form.get('email').hasError('required')
                    "
                >
                    Su email es requerido.
                </mat-error>
                <mat-error
                    *ngIf="
                        form.get('email').touched &&
                        form.get('email').hasError('email')
                    "
                >
                    Su email no posee el formato correcto.
                </mat-error>
                <mat-error
                    *ngIf="
                        form.get('email').touched &&
                        form.get('name').hasError('maxlength')
                    "
                >
                    Su nombre debe contener como máximo 200 caracteres.
                </mat-error>
            </mat-form-field>
            <!-- End Email -->

            <section *ngIf="isRent">
                <!-- Start País -->
                <mat-form-field appearance="fill">
                    <mat-label>País</mat-label>
                    <mat-select
                        formControlName="country"
                        [(value)]="contact"
                        tabindex="-1"
                        (selectionChange)="changeCountry($event.value)"
                    >
                        <mat-option
                            *ngFor="let contact of allContactList"
                            [value]="contact"
                        >
                            <span class="flag">
                                <img
                                    src="{{ contact.flag_url }}"
                                    alt="{{ contact.country }}"
                                />
                            </span>
                            <span class="country">{{ contact.country }}</span>
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <!-- End País -->

                <ng-container *ngIf="!hidden">
                    <!-- Start Región -->
                    <mat-form-field appearance="fill">
                        <mat-label>Región</mat-label>
                        <mat-select
                            formControlName="region"
                            (selectionChange)="changeRegion($event.value)"
                        >
                            <mat-option
                                *ngFor="let Region of chile"
                                [value]="Region"
                                >{{ Region.region }}</mat-option
                            >
                        </mat-select>
                    </mat-form-field>
                    <!-- End Región -->

                    <!-- Start Comuna -->
                    <mat-form-field appearance="fill">
                        <mat-label>Comuna</mat-label>
                        <mat-select
                            formControlName="comuna"
                            (selectionChange)="changeComuna($event.value)"
                        >
                            <mat-option
                                *ngFor="let comuna of region.comunas"
                                [value]="comuna"
                                >{{ comuna }}</mat-option
                            >
                        </mat-select>
                    </mat-form-field>
                    <!-- End Comuna -->
                </ng-container>
            </section>

            <button
                mat-button
                id="sb-btn-call"
                class="btn btn_blue upper"
                [class.preloader]="isSendForm"
                [disabled]="form.invalid || disableButton"
                (click)="sendForm()"
            >
                <mat-spinner *ngIf="isSendForm" [diameter]="24"></mat-spinner>
                {{ btnMsg() }}
            </button>
        </div>
    </form>
    <!-- END from -->
</section>

<app-footer></app-footer>
